// @flow

import _ from "underscore";

/**
 * Converts object to URL query parameters string.
 * Array values will be converted to comma-separated values
 * @param params Parameters object. Values can be numbers, strings or arrays
 * @returns {string} Query string
 */
function paramsToQuery(params: ?{}): string {
    if (params == null) return "";
    params = _.omitBy(params, _.isUndefined);
    params = _.omitBy(params, _.isNull);
    let fixedParams = _.mapValues(params, function (value) {
        if (value && value.constructor === Array) return value.join(",");
        return value;
    });
    return new URLSearchParams(Object.entries(fixedParams)).toString();
}


export {paramsToQuery};
